import React from "react"

export default class AddButtons extends React.Component {

  renderButton(type, label) {
    return (
      <div className="button" onClick={() => this.props.onClick(type, this.props.index)}>
        {"+ " + label}
      </div>
    )
  }

  render() {
    const { quote } = this.props

    return (
      <div className="row-buttons">
        { quote.mbc_contract?.id &&
          this.renderButton("bpu", I18n.t("mbc_contracts.mbc_lines.short_label"))
        }

        {this.renderButton("regular", I18n.t("quotes.new.line"))}

        { quote.account.allow_qline_services &&
          this.renderButton("service", I18n.t("quotes.new.service"))
        }

        { quote.account.allow_qline_groups &&
          this.renderButton("group", I18n.t("quotes.new.qline_group"))
        }

        { quote.account.allow_qline_blueprints &&
          this.renderButton("blueprint", I18n.t("quotes.new.qline_blueprint"))
        }

        {this.renderButton("descriptive", I18n.t("quotes.new.descriptive_line"))}

        { quote.account.allow_products &&
          this.renderButton("product", I18n.t("quotes.new.product"))
        }

        {this.renderButton("break",    I18n.t("quotes.new.page_break"))}
        {this.renderButton("subtotal", I18n.t("quotes.new.subtotal"))}
        {this.renderButton("section",  I18n.t("quotes.new.section"))}
      </div>
    )
  }
}
